import React from 'react';

export const BottomNav = ({ onPrev, onNext, onMemorize, disabled, isMemorized }) => {
  return (
    <div className="bottom-nav">
      <button className="nav-btn" onClick={onPrev} disabled={disabled}>
        ←
      </button>
      <button 
        className="nav-btn nav-btn-primary" 
        onClick={onMemorize} 
        disabled={disabled}
      >
        {isMemorized ? '✓ Done' : 'Mark Done'}
      </button>
      <button className="nav-btn" onClick={onNext} disabled={disabled}>
        →
      </button>
    </div>
  );
};
